// South African merchant metadata for logos + brand colours.
const MERCHANTS = [
  { match: ["pick n pay", "pnp", "pick'n"], domain: "picknpay.co.za", color: "#E4002B" },
  { match: ["checkers"], domain: "checkers.co.za", color: "#E2001A" },
  { match: ["woolworths", "woolies"], domain: "woolworths.co.za", color: "#0A0A0A" },
  { match: ["shoprite"], domain: "shoprite.co.za", color: "#E30613" },
  { match: ["spar"], domain: "spar.co.za", color: "#006B3F" },
  { match: ["engen"], domain: "engen.co.za", color: "#C8102E" },
  { match: ["shell"], domain: "shell.com", color: "#DD1D21" },
  { match: ["bp"], domain: "bp.com", color: "#009900" },
  { match: ["sasol"], domain: "sasol.com", color: "#0033A0" },
  { match: ["total"], domain: "totalenergies.com", color: "#ED0000" },
  { match: ["mcdonald"], domain: "mcdonalds.com", color: "#DA291C" },
  { match: ["kfc"], domain: "kfc.co.za", color: "#A6192E" },
  { match: ["nando"], domain: "nandos.co.za", color: "#DC241F" },
  { match: ["steers"], domain: "steers.co.za", color: "#E30613" },
  { match: ["clicks"], domain: "clicks.co.za", color: "#E5007D" },
  { match: ["dis-chem", "dischem"], domain: "dischem.co.za", color: "#00A651" },
  { match: ["takealot"], domain: "takealot.com", color: "#0BA5EC" },
  { match: ["game"], domain: "game.co.za", color: "#E4002B" },
  { match: ["makro"], domain: "makro.co.za", color: "#003DA5" },
  { match: ["mr price", "mrp"], domain: "mrp.com", color: "#E4002B" },
];

const PALETTE = [
  "#6E3FFC", "#2BB0C4", "#F5A623", "#42C97C", "#FF6B6B", "#8B6DFF",
  "#38BDF8", "#F472B6", "#14B8A6", "#805AD5", "#FFAA00", "#5A67D8",
  "#EC4899", "#0EA5E9", "#22B573", "#F97316", "#A855F7", "#E11D8F",
];

function hashColor(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = str.charCodeAt(i) + ((h << 5) - h);
  return PALETTE[Math.abs(h) % PALETTE.length];
}

// Deterministic, vibrant hue per merchant name (used for initials avatars).
export function merchantHue(name = "") {
  return hashColor((name || "x").trim().toLowerCase());
}

export function merchantMeta(name = "") {
  const n = name.toLowerCase();
  const words = name.trim().split(/\s+/).filter(Boolean);
  const initials = (words[0]?.[0] || "?") + (words[1]?.[0] || "");
  const found = MERCHANTS.find((m) => m.match.some((k) => n.includes(k)));
  return {
    domain: found?.domain || null,
    color: merchantHue(name),
    initials: initials.toUpperCase(),
  };
}
